/*
 * Module um pouco diferente, usado para upload, download e delete de documentos
 * Não lista, Não discarta mudanças
 */
import {
  TIPO_DOC_CATEGORIA_DISCIPLINA,
  TIPO_DOC_CATEGORIA_CURSO,
  TIPO_DOC_CATEGORIA_AUTOR
} from "@/common/config";
import ApiGael from "@/services/apiGael.service";
import { SIGN_URL } from "@/store/actions/actions.type";
import { SIGN_URL_START, SIGN_URL_END } from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  documento: {
    id: undefined,
    nome: "",
    nomeS3: "",
    path: "",
    mimetype: "",
    tamanho: undefined,
    tipoDocumento: {
      id: undefined
    },
    disciplina: {
      id: undefined
    },
    curso: {
      id: undefined
    }
  }
});

const state = {
  isSigningUrl: false
};

const getters = {
  documentos(state) {
    return state.documentos;
  },
  documento(state) {
    return state.documento;
  },
  documentoOriginal(state) {
    return state.documentoOriginal;
  },
  isSigningUrl(state) {
    return state.isSigningUrl;
  }
};

const actions = {
  [SIGN_URL](context, documentS3Key) {
    return new Promise((resolve, reject) => {
      context.commit(SIGN_URL_START);

      ApiGael.post("documentos/eadstock/download", { s3Key: documentS3Key })
        .then(response => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          context.commit(SIGN_URL_END);
        });
    });
  }
};

const mutations = {
  [SIGN_URL_START](state) {
    state.isSigningUrl = true;
  },
  [SIGN_URL_END](state) {
    state.isSigningUrl = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
